import { useMutation, useQueryClient } from '@tanstack/react-query';

import { displayToastError } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateRoleRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { updateRoles } from '../../api/roles.api';

/**
 * Hook to update roles in bulk (create new, update existing).
 * Invalidates role queries and team member queries (which use roles as dropdown options).
 */
export const useUpdateRoles = () => {
  const queryClient = useQueryClient();
  const { getErrorMessage } = useApiError();

  return useMutation({
    mutationFn: updateRoles,
    onSuccess: async () => {
      // Invalidate role and team member queries
      await invalidateRoleRelatedQueries(queryClient);
    },
    onError: (error: unknown) => {
      displayToastError(getErrorMessage(error, true));
    },
  });
};
